import React from 'react';
import { Modal as AntModal } from 'antd-v5';
import closeIcon from '@/common/images/close.png';
import './style.less';
function Modal(props) {
  const { ...nativeProps } = props;

  return (
    <AntModal
      {...nativeProps}
      className='ui-modal'
      closeIcon={<img style={{ width: 20, height: 20 }} src={closeIcon} alt='close' />}
    />
  );
}
Modal.confirm = AntModal.confirm;
Modal.info = AntModal.info;
Modal.success = AntModal.success;
Modal.error = AntModal.error;
Modal.warning = AntModal.warning;
Modal.open = AntModal.open;
Modal.clear = AntModal.clear;
Modal.destroy = AntModal.destroy;
Modal.show = AntModal.show;
Modal.hide = AntModal.hide;
Modal.useModal = AntModal.useModal;
export default Modal;
